import React from 'react';
import { motion } from 'motion/react';

export interface StyledCalloutProps {
  accentColor?: string;
  accentText?: string;
  lines?: string[];
  text: string;
  textClassName?: string;
  children?: React.ReactNode;
}

export const StyledCallout: React.FC<StyledCalloutProps> = ({
  accentColor = 'border-brand-blue dark:border-brand-blue',
  accentText,
  lines,
  text,
  textClassName,
  children,
}) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5 }}
      className={`mb-12 pl-6 border-l-4 ${accentColor}`}
    >
      <div className={textClassName || 'text-xl md:text-2xl font-medium mb-4'}>{text}</div>
      {accentText && (
        <div className="text-lg text-zinc-600 dark:text-zinc-400 mb-2">
          {accentText}
        </div>
      )}
      {lines && lines.length > 0 && (
        <ul className="list-disc pl-5 space-y-1 text-zinc-600 dark:text-zinc-400">
          {lines.map((line, index) => (
            <li key={index} className="text-base">
              {line}
            </li>
          ))}
        </ul>
      )}
      {children}
    </motion.div>
  );
};
